export const RACE_ETHNICITY_OPTIONS = [
  { value: "American Indian or Alaska Native", label: "American Indian or Alaska Native" },
  { value: "Asian", label: "Asian" },
  { value: "Black or African American", label: "Black or African American" },
  { value: "Hispanic or Latino", label: "Hispanic or Latino" },
  { value: "Middle Eastern or North African", label: "Middle Eastern or North African" },
  { value: "Native Hawaiian or Other Pacific Islander", label: "Native Hawaiian or Other Pacific Islander" },
  { value: "White", label: "White" },
  { value: "Other (Please Specify)", label: "Other (Please Specify)" },
  { value: "Prefer not to say / Decline to answer", label: "Prefer not to say / Decline to answer" },
];

export const RACE_ETHNICITY_OTHER_VALUE = "Other (Please Specify)";
export const RACE_ETHNICITY_PREFER_NOT_VALUE = "Prefer not to say / Decline to answer";

const RACE_ETHNICITY_VALUES = new Set(RACE_ETHNICITY_OPTIONS.map((o) => o.value));

export function normalizeRaceEthnicityArray(raw) {
  const list = Array.isArray(raw) ? raw : raw != null && raw !== "" ? [raw] : [];
  const out = [];
  for (const item of list) {
    const s = item != null ? String(item).trim() : "";
    if (!s || !RACE_ETHNICITY_VALUES.has(s)) continue;
    if (!out.includes(s)) out.push(s);
  }
  if (out.includes(RACE_ETHNICITY_PREFER_NOT_VALUE) && out.length > 1) {
    return [RACE_ETHNICITY_PREFER_NOT_VALUE];
  }
  return out;
}

export function toggleRaceEthnicityValue(current, optionValue) {
  const value = optionValue != null ? String(optionValue).trim() : "";
  if (!value || !RACE_ETHNICITY_VALUES.has(value)) return normalizeRaceEthnicityArray(current);
  const cur = normalizeRaceEthnicityArray(current);
  const has = cur.includes(value);
  if (value === RACE_ETHNICITY_PREFER_NOT_VALUE) {
    return has ? [] : [RACE_ETHNICITY_PREFER_NOT_VALUE];
  }
  const withoutPrefer = cur.filter((v) => v !== RACE_ETHNICITY_PREFER_NOT_VALUE);
  if (has) return withoutPrefer.filter((v) => v !== value);
  return [...withoutPrefer, value];
}

export function getRaceEthnicityDisplayLabel(selectionsRaw, otherRaw) {
  const selections = normalizeRaceEthnicityArray(selectionsRaw);
  if (selections.length === 0) return "—";
  return selections
    .map((v) => {
      if (v === RACE_ETHNICITY_OTHER_VALUE) {
        const other = otherRaw != null ? String(otherRaw).trim() : "";
        return other || v;
      }
      return v;
    })
    .join(", ");
}

/** Closed dropdown trigger text (compact). */
export function getRaceEthnicityTriggerLabel(selectionsRaw, otherRaw) {
  const selections = normalizeRaceEthnicityArray(selectionsRaw);
  if (selections.length === 0) return "Select…";
  if (selections.length === 1) {
    const only = selections[0];
    if (only === RACE_ETHNICITY_OTHER_VALUE) {
      const other = otherRaw != null ? String(otherRaw).trim() : "";
      return other || only;
    }
    return only;
  }
  return `${selections.length} selected`;
}

export function validateRequiredSchoolDistrict(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "School district is required.";
  return "";
}

export function validateRequiredRaceEthnicity(selectionsRaw, otherRaw) {
  const selections = normalizeRaceEthnicityArray(selectionsRaw);
  if (selections.length === 0) return "Race / Ethnicity is required.";
  if (selections.includes(RACE_ETHNICITY_OTHER_VALUE)) {
    const other = otherRaw != null ? String(otherRaw).trim() : "";
    if (!other) return "Please specify race / ethnicity.";
  }
  return "";
}

export function buildChildProfilePayload(row) {
  const preferred_name = row?.preferred_name != null ? String(row.preferred_name).trim() : "";
  const school_district = row?.school_district != null ? String(row.school_district).trim() : "";
  const race_ethnicity = normalizeRaceEthnicityArray(row?.race_ethnicity);
  const race_ethnicity_other =
    race_ethnicity.includes(RACE_ETHNICITY_OTHER_VALUE) && row?.race_ethnicity_other != null
      ? String(row.race_ethnicity_other).trim()
      : "";
  const out = {
    preferred_name,
    school_district,
    race_ethnicity,
    race_ethnicity_other,
  };
  if (row?.photography_consent === true || row?.photography_consent === false) {
    out.photography_consent = row.photography_consent;
  }
  return out;
}
